import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Row, Col, Well } from 'react-bootstrap';
import windowSize from 'react-window-size';
import _ from 'lodash';
import Table from './Table';
import { getWorkflowTranslationHashTable,
         getExtraData } from '../../helpers/utils';
import { dialogHeaderFooterBgColor } from '../../helpers/colors';


export const getPlaceholderRows = (user, config, currentCase) => {
    const extraData = getExtraData(currentCase, config, user, true);
    let rows = getWorkflowTranslationHashTable(config, currentCase, {}, undefined, true);
    Object.keys(extraData).forEach((key) => {
        const placeholder = `{${key}}`;
        const existingField = rows.find(x => x.placeholder === placeholder);
        if (existingField) {
            existingField.value = extraData[key];
        } else {
            rows.unshift({
                placeholder,
                table: 'field',
                label: extraData[key].label,
                value: extraData[key].value,
            });
        }
    });

    rows = rows.sort((a, b) => {
        a = a.placeholder.replace('%', '');
        b = b.placeholder.replace('%', '');
        return a.localeCompare(b);
    }).filter((item, pos, arr) => {
        return pos === 0 || item.placeholder !== arr[pos - 1].placeholder;
    });

    rows = rows.map(x => { return { field: x }; } );
    return rows;
};

export const placeholderTableHeader = [{
    table: 'field',
    name: 'placeholder',
    label: 'Placeholder',
    width: 300,
},
{
    table: 'field',
    name: 'label',
    label: 'Label',
    width: 400,
},
{
    table: 'field',
    name: 'value',
    label: 'Value after replacing (if case is opened)',
}];


class TemplatesHelpDialog extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.rows = [];
    }

    componentDidUpdate() {
        if (!__CLIENT__) {
            return;
        }

        const copyRowContainer = document.getElementById('template-dialog-container');
        if (!_.isEqual(copyRowContainer, this.copyRowContainer)) {
            this.copyRowContainer = copyRowContainer;
            this.forceUpdate();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.rows = getPlaceholderRows(nextProps.user, nextProps.config, nextProps.currentCase);
    }

    componentWillUnmount() {
        this.copyRowContainer = null;
    }

    render() {
        const {
            open,
            cancel,
            config,
            currentCase,
            width,
        } = this.props;

        //
        // Format so the Table component loads the rows correctly.
        //

        const loading = typeof(config) == 'undefined' || typeof(currentCase) == 'undefined';
        const height = this.props.windowHeight * 0.55;
        return (
            <Modal show={open}
                   onHide={cancel}
                   backdrop='static'
                   dialogClassName='modal-dialog-full'>
                <Modal.Header closeButton style={{ backgroundColor: dialogHeaderFooterBgColor }}>
                    <Modal.Title>Templates Help</Modal.Title>
                </Modal.Header>
                <Modal.Body id="template-dialog-container">
                <Row>
                    <Col xs={12}>
                        <Well>Use the fields {'{FIELD}'} below in your email or Microsoft Word document templates in order to have it replaced by value
                        like the one on the right. You can use the search fields under the column names to find the field you are looking for. <i>Pro tip:</i> Values in the format of {'FIELD_DIGIT'} select a given word from current value.</Well>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} style={{height, width}}>
                        <Table
                            headers={placeholderTableHeader}
                            copyRow={row => row.field.placeholder}
                            copyRowContainer={this.copyRowContainer}
                            rows={this.rows}
                            loading={loading}
                            defaultPageSize={this.rows.length || 100}
                        />
                    </Col>
                </Row>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        config: state.user.config,
        currentCase: state.cases.current,
        user: state.user.loggedIn,
    };
};

TemplatesHelpDialog.propTypes = {
    cancel: PropTypes.func,
    open: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(windowSize(TemplatesHelpDialog));
